// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_7qx52","ProjectsTabs":"ProjectsTabs_H59Vn","ProjectsOperationButton":"ProjectsOperationButton_muOEi"};